import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchChapterProgress } from '@cap/share/src/apis/courseDetail';
import { RootState } from '@/store';
import { ICourseChapter, ICourseLesson, ILessonProgressDto } from './utils/type';
import { getLessonList } from './utils/func';

interface ICatalogState {
  chapterList: ICourseChapter[];
  chapterProgress: ILessonProgressDto[];
  selectedLessonInfo: ICourseLesson | null;
}

const initialState: ICatalogState = {
  chapterList: [],
  chapterProgress: [],
  selectedLessonInfo: null,
};

export const getChapterProgress = createAsyncThunk(
  'courseDetailStore/getChapterProgress',
  async (props: { id: number }, { getState }) => {
    try {
      const { id: courseId } = props;
      const state = getState() as RootState;
      const { courseDetail } = state.detailCourseData.base;
      const { type: courseType, shortUrl: tenant, tenantId } = courseDetail!;
      const { chapterList: chapters } = state.detailCourseData.catalog;
      const chapterIds = getLessonList(chapters).map((item) => item.id);
      const res = await fetchChapterProgress<ILessonProgressDto[]>(
        { courseId, courseType, chapterIds },
        { tenant, tenantId },
      );
      return res.data;
    } catch (error: any) {
      return null;
    }
  },
);

const chapterSlice = createSlice({
  name: 'catalog',
  initialState,
  reducers: {
    setChapterList: (state, action) => {
      state.chapterList = action.payload;
    },
    setSelectedLessonInfo: (state, action) => {
      state.selectedLessonInfo = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getChapterProgress.fulfilled, (state, action) => {
      const progress = action.payload;
      if (progress?.length) {
        state.chapterProgress = progress;
      }
    });
  },
});

export default chapterSlice.reducer;

export const { setChapterList, setSelectedLessonInfo } = chapterSlice.actions;
export const selectChapterList = (state: RootState) => state.detailCourseData.catalog.chapterList;
export const selectChapterProgress = (state: RootState) => state.detailCourseData.catalog.chapterProgress;
export const selectSelectedLessonInfo = (state: RootState) => state.detailCourseData.catalog.selectedLessonInfo;
